import React, { useState } from 'react';
import Input, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import flags from 'react-phone-number-input/flags';
import { Label } from '@/components/ui/label';

interface PhoneFieldProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
}

export const PhoneField: React.FC<PhoneFieldProps> = ({
  value,
  onChange,
  label = 'Phone Number',
  placeholder = 'Enter phone number',
  required = false,
  className,
  inputClassName,
  labelClassName,
}) => {
  const [error, setError] = useState('');
  const [touched, setTouched] = useState(false);

  const handleChange = (val = '') => {
    onChange(val);
    setError('');
  };

  const handleBlur = () => {
    setTouched(true);
    if (required && (!value || value.trim() === '')) {
      setError('Phone number is required.');
    } else if (value && !isValidPhoneNumber(value, 'US')) {
      setError('Please enter a valid US phone number.');
    } else {
      setError('');
    }
  };

  return (
    <div className={className}>
      {label && (
        <Label className={labelClassName ?? 'text-sm font-medium text-slate-700'}>
          {label} {required && <span className="text-red-500">*</span>}
        </Label>
      )}
      <div className="mt-2">
        <Input
          international
          defaultCountry="US"
          countryCallingCodeEditable={false}
          value={value || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          flags={flags}
          placeholder={placeholder}
          countrySelectProps={{ disabled: true }}
          className={inputClassName ?? 'rounded-lg'}
        />
      </div>
      {error && touched && (
        <p className="text-[0.8rem] text-red-500 mt-1">{error}</p>
      )}
    </div>
  );
};


